import store from "@/store";

export default function (
  message,
  color,
  timeout
) {
  store.commit("snackbar/show", { message, color, timeout });
}
